export default __webpack_public_path__ + "static/media/m-review1.63148d00.png";